module.exports = __webpack_public_path__ + "images/6a25865e37fae17149cd56086beea4b9-logo_alpha.png";